/// <amd-module name="Wit/Admin/components/ProjectOverviewProcessSectionComponent" />
import * as React from "react";
import {VssComponent } from "VSS/Platform/Layout";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { routeUrl } from "VSS/Platform/Location";

interface ProjectOverviewProcessSectionComponentState {
    processTemplateName: string;
}

interface IProjectsProcessData{
    processTemplateName: string;
}

const dataProviderId = "ms.vss-admin-web.project-admin-overview-data-provider";

class ProjectOverviewProcessSectionComponent extends VssComponent<{}, ProjectOverviewProcessSectionComponentState> {

    public constructor(props: {}, context?: any) {
        super(props, context);
        const contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
        const projectsProcessData = contributionService.getData<IProjectsProcessData>(dataProviderId)!;
        this.state = { processTemplateName: projectsProcessData.processTemplateName };
    }

    public render(): JSX.Element {
        const processTemplateName = this.state.processTemplateName;
        const processUrl = routeUrl(this.context.pageContext, "ms.vss-work-web.work-customization-route", { _a: "workitemtypes", "process-name": processTemplateName });
        return (
            <div>
                <h5 className="fontSizeM" role="none">Process</h5>
                <div className="processTemplateName"><a href={processUrl}>{processTemplateName}</a></div>
            </div>
        );
    }
}

VssComponent.register("work-projectoverview-process-component-section", ProjectOverviewProcessSectionComponent);
